import { urlBaseLeadCollector } from "../config";
import axios from "axios";
import { store } from "../../store/configStore";
import StandModel from '../../models/StandModel';

export default async function getStands(
  eventId = '',
  search = '',
  limit = 10,
  offset = 0,
  orderBy = 'organization_name',
  order = 'ASC',
) {
  try {
    const token = store.getState().global_user_data?.data?.token;
    const _ret = await axios({
      method: 'GET',
      url: `${urlBaseLeadCollector}/adminPlus/getStands?adminPlusEventId=${eventId}&offset=${offset}&limit=${limit}&search=${search}&orderBy=${orderBy}&order=${order}`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    let _return = {
      data: [StandModel()],
      count: 0,
    }
    _return.data = [];

    for (let i = 0; i < _ret.data?.data?.data?.length; i++) {
      _return.data.push(StandModel({ ..._ret.data?.data?.data[i] }));
    }
    _return.count = _ret.data?.data?.count;

    return _return;
  } catch (error) {
    console.log('Error getStands', error);
    throw error;
  }
}
